import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  FormControl,
  Card,
} from "@mui/material";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledDatePicker,
  OutlinedIconFab,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import { durationType } from "../initialData/initialData";
import {
  getHumanReadableDiffInPastDate,
  getHumanReadableDurationInDate,
} from "../Utils/UtilsFunctions";
import Icon from "../Utils/Icons";

const MedicalHistory = ({
  medicalHistoryData,
  setMedicalHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Medical History called", medicalHistoryData);
  const today = dayjs();
  const [chiefComplaintsStatus, setChiefComplaintsStatus] = useState([
    "Active",
    "Recurrence",
    "Relapse",
    "Inactive",
    "Remission",
    "Resolved",
    "Unknown",
  ]);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalledCondition, setDebounceFunctionCalledCondition] =
    useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const [medicalHistoryVars, setMedicalHistoryVars] = useState({
    condition: "",
    id: null,
    onset_datetime: null,
    clinical_status_description: "Active",
    abatement_datetime: null,
    clinical_note: "",
    duration: "",
    chiefComplaintDurationType: "days",
    abatement_duration: "",
    abatement_duration_type: "days",
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [conditionName, setConditionName] = useState("");

  const [clinicalNotesListening, setClinicalNotesListening] = useState(false);
  const [error, setError] = useState("");
  const [medicalHistoryEditIndex, setMedicalHistoryEditIndex] = useState(null);
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);
  console.log("medicalHistoryVars", medicalHistoryVars);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  useEffect(() => {
    if (activeHistorySection == "Medical History") {
      let timerId;
      // alert(`MH ${transcript}`);
      timerId = setTimeout(() => {
        if (clinicalNotesListening) {
          setMedicalHistoryVars({
            ...medicalHistoryVars,
            clinical_note: transcript, // Use computed property name to set the field dynamically
          });
        } else {
          setConditionName(transcript);
        }
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);
  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when conditionName changes

    let timerOut = setTimeout(() => {
      if (conditionName.trim() !== "") {
        debouncedConditionFilterCall(conditionName.toLowerCase());
      }
    }, 1000);
    return () => clearInterval(timerOut);
  }, [conditionName]);

  const startListening = (key) => {
    // alert("MH SL");
    if (transcript) {
      resetTranscript();
    }
    setActiveHistorySection("Medical History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
    if (key == "condition") {
      setClinicalNotesListening(false);
    } else {
      setClinicalNotesListening(true);
    }
  };
  const handleAddRow = async () => {
    // console.log("Add Click", medicalHistoryVars);
    if (medicalHistoryVars.condition || conditionName.length > 0) {
      // Store the updated state in a local variable

      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "-1",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (conditionName.length > 2) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...medicalHistoryVars,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...medicalHistoryVars,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...medicalHistoryVars,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...medicalHistoryVars,
            condition: conditionName,
            id: null,
          };
        }
      } else {
        newDetails = { ...medicalHistoryVars };
      }

      const newRow = {
        condition: newDetails.condition,
        id: newDetails.id,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),
        clinical_status_description: newDetails.clinical_status_description,
        abatement_datetime: newDetails?.abatement_datetime
          ? newDetails?.abatement_datetime.format("YYYY-MM-DD")
          : null,
        clinical_note: newDetails?.clinical_note,
        duration: newDetails?.duration,
        chiefComplaintDurationType: newDetails?.chiefComplaintDurationType,
        abatement_duration: newDetails?.abatement_duration,
        abatement_duration_type: newDetails?.abatement_duration_type,
      };

      // Update family history rows by adding the new row

      const updatedRows = [...medicalHistoryData["new"], newRow];

      setMedicalHistoryData({
        ...medicalHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setMedicalHistoryVars({
        ...medicalHistoryVars,
        condition: "",
        clinical_note: "",
        abatement_duration: "",
        abatement_duration_type: "days",
        abatement_datetime: null,
        clinical_status_description: "Active",
      });
      setConditionName("");
      setError("");
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      optionChosen.current = false;
      setFilteredOptions([]);
    } else {
      // Set error message if any field is missing
      setError("Condition Name field is mandatory");
    }
  };
  const handleMedicalHistoryEditClick = (row, rowIndex) => {
    setConditionName(row.condition);
    setMedicalHistoryVars({
      condition: "",
      id: null,
      onset_datetime: row.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row?.abatement_datetime
        ? dayjs(row?.abatement_datetime)
        : null,
      clinical_status_description: row?.clinical_status_description,
      clinical_note: row?.clinical_note,
      duration: row?.duration,
      chiefComplaintDurationType: row?.chiefComplaintDurationType,
      abatement_duration: row?.abatement_duration,
      abatement_duration_type: row?.abatement_duration_type,
    });
    setMedicalHistoryEditIndex(rowIndex);
  };
  const handleMedicalHistoryUpdate = async () => {
    // console.log("Update Click", medicalHistoryVars);
    if (medicalHistoryVars.condition || conditionName.length > 0) {
      // Store the updated state in a local variable

      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "-1",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (conditionName.length > 2) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...medicalHistoryVars,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...medicalHistoryVars,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...medicalHistoryVars,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...medicalHistoryVars,
            condition: conditionName,
            id: null,
          };
        }
      } else {
        newDetails = { ...medicalHistoryVars };
      }

      const updatedRow = {
        condition: newDetails?.condition,
        id: newDetails?.id,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),
        abatement_datetime:
          newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        clinical_status_description: newDetails?.clinical_status_description,
        clinical_note: newDetails?.clinical_note,
        duration: newDetails?.duration,
        chiefComplaintDurationType: newDetails.chiefComplaintDurationType,
        abatement_duration: newDetails?.abatement_duration,
        abatement_duration_type: newDetails?.abatement_duration_type,
        source: undefined,
      };

      // Update family history rows by adding the new row

      const updatedMedicalHistory = medicalHistoryData["new"].map(
        (row, index) => {
          if (index === medicalHistoryEditIndex) {
            return updatedRow;
          } else {
            return row;
          }
        }
      );
      setMedicalHistoryData({
        ...medicalHistoryData,
        new: updatedMedicalHistory,
      });
      // Reset family history variables and clear error
      setMedicalHistoryVars({
        ...medicalHistoryVars,
        condition: "",
        clinical_note: "",
        abatement_duration: "",
        abatement_duration_type: "days",
        abatement_datetime: null,
        clinical_status_description: "Active",
      });
      setConditionName("");

      setMedicalHistoryEditIndex(null);
      setError("");
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      setFilteredOptions([]);
      optionChosen.current = false;
    } else {
      // Set error message if any field is missing
      setError("Condition Name field is mandatory");
    }
  };
  const handleMedicalHistoryDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedMedicalHistory = medicalHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setMedicalHistoryData({
      ...medicalHistoryData,
      new: updatedMedicalHistory,
    });
  };
  const calculateOnsetDate = (duration, type) => {
    if (!duration) return null;
    const today = dayjs(); // Current date
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    return today.subtract(duration, durationMap[type]);
  };

  const calculateAbatementDate = (onset_datetime, duration, type) => {
    if (
      duration === null ||
      duration === undefined ||
      isNaN(parseInt(duration)) ||
      !onset_datetime
    )
      return null;
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    console.log(
      "date abatement",
      dayjs(onset_datetime).add(duration, durationMap[type])
    );
    return dayjs(onset_datetime).add(duration, durationMap[type]);
  };

  const handleChangeMedicalHistory = (field, value) => {
    let newDetails;
    if (field == "condition") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
      newDetails = {
        ...medicalHistoryVars,
        [field]: value.term,
        id: value.id,
      };
    } else {
      newDetails = {
        ...medicalHistoryVars,
        [field]: value,
      };
    }

    if (field === "duration" || field === "chiefComplaintDurationType") {
      const newOnsetDate = calculateOnsetDate(
        field === "duration" ? value : newDetails.duration,
        field === "chiefComplaintDurationType"
          ? value
          : newDetails.chiefComplaintDurationType
      );
      newDetails = {
        ...newDetails,
        onset_datetime: newOnsetDate,
      };
    }
    if (field === "abatement_duration" || field === "abatement_duration_type") {
      const abatementDuration =
        field === "abatement_duration" ? value : newDetails?.abatement_duration;
      const abatementDurationType =
        field === "abatement_duration_type"
          ? value
          : newDetails?.abatement_duration_type;

      const newAbatementDate = calculateAbatementDate(
        newDetails?.onset_datetime,
        abatementDuration,
        abatementDurationType
      );

      newDetails = {
        ...newDetails,
        abatement_datetime: abatementDuration ? newAbatementDate : null,
      };
    }

    setMedicalHistoryVars(newDetails);
  };
  const handleClearConditionName = () => {
    setError("");
    setConditionName("");
    resetTranscript();
    setMedicalHistoryVars({
      ...medicalHistoryVars,
      condition: "", // Use computed property name to set the field dynamically
    });
    setTermSelectedOrAdded(false);
    setFilteredOptions([]);
    setDebounceFunctionCalledCondition(false);
    // setMedicineList([])
  };
  const handleClearClinicalNotes = () => {
    setError("");

    resetTranscript();
    setMedicalHistoryVars({
      ...medicalHistoryVars,
      clinical_note: "", // Use computed property name to set the field dynamically
    });
    // setMedicineList([])
  };
  const debouncedConditionFilterCall = async (medicine) => {
    console.log("Debounce function called");
    let semanticTagForConditionSearch = "finding++disorder";
    const postBody = {
      term: medicine,
      state: "active",
      semantictag: semanticTagForConditionSearch,
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (conditionName.length > 2) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((medicineItem) => {
              return {
                term: medicineItem.term,
                id: medicineItem.conceptId,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              if (conditionName.length > 2) {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBody,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);
                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;
                    setAutoCompleteData(dataToProcess);
                    setFilteredOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredOptions([]);
                  }
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalledCondition(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  }; // Adjust the debounce duration (in milliseconds) as needed
  const handleAddOption = async (term) => {
    const postBody = {
      term: term,
      state: "active",
      semantictag: "finding++disorder",
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (conditionName.length > 2) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          let updatedFound = {},
            updatedSelectedOptiondetsils = {},
            foundData = false;
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            foundData = response.data.data.find((d) => d.term === term);
            console.log("Found Data", foundData);
            if (foundData) {
              updatedFound = {
                ...foundData,
                found: true,
                id: foundData.conceptId,
              };
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: term,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: term,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }
          } else {
            updatedSelectedOptiondetsils = {
              hierarchy: null,
              isPreferredTerm: null,
              conceptState: null,
              conceptFsn: term,
              definitionStatus: null,
              conceptId: null,
              languageCode: "en",
              typeId: null,
              term: term,
              caseSignificanceId: "CASE_INSENSITIVE",
              id: null,
              effectiveTime: null,
              activeStatus: null,
              moduleId: null,
            };
          }

          setAutoCompleteData([]);
          setFilteredOptions([]);
          setSuggestApiCalled(false);
          setDebounceFunctionCalledCondition(true);
          if (foundData) {
            handleChangeMedicalHistory("condition", updatedFound);
          } else {
            handleChangeMedicalHistory(
              "condition",
              updatedSelectedOptiondetsils
            );
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };

  const handleConditionTyped = (value) => {
    setConditionName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "0 4px 4px 0 #C7C7CC inset",
        backgroundColor: "#FFF",
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}
      >
        <Grid item xs={11} sm={11} md={11} sx={{ margin: "5px 0px" }}>
          <StyledTextField
            label="Condition Name"
            variant="outlined"
            value={
              // medicalHistoryVars.condition !== ""
              //   ? medicalHistoryVars.condition
              //   :
              conditionName
            }
            onChange={(e) => {
              // if (!medicalHistoryVars.condition) {
              //   setConditionName(e.target.value);
              // }
              handleConditionTyped(e.target.value);
            }}
            fullWidth
            onBlur={() => {
              setTimeout(() => {
                const shouldClear = !mouseDownOnOption;

                if (shouldClear) {
                  // setIsFocused(false);
                  setFilteredOptions([]);
                  setDebounceFunctionCalledCondition(false);
                  setTermSelectedOrAdded(false);
                }

                setMouseDownOnOption(false);
              }, 100);
            }}
            onFocus={() => {
              // setIsFocused(true);
              if (conditionName.trim() !== "") {
                debouncedConditionFilterCall(conditionName.toLowerCase()); // re-trigger filtering
              }
            }}
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearConditionName}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>
                  {/* {!termSelectedOrAdded && (
                    <Tooltip title="Add" style={{ marginRight: "5px" }}>
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleAddOption}
                      >
                        <AddIcon />
                      </OutlinedIconFab>
                    </Tooltip>
                  )} */}
                  <>
                    {isAiEnabled &&
                      (listeningOn === false ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="defaultColor"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : listeningOn === true &&
                        clinicalNotesListening === true ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="default"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Stop Listening">
                          <OutlinedIconFab
                            onClick={() => {
                              // SpeechRecognition.stopListening();
                              stopRecording("Medical History");
                              setListeningOn(false);
                            }}
                            variant="outlined"
                            color="default"
                            size="small"
                          >
                            <Icon name="micInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ))}
                  </>
                </div>
              ),
            }}
          />
          {filteredOptions.length > 0 ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "200px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
                // position: "absolute", // Position it absolutely
                // zIndex: 1000, // Set a high z-index value to bring it over other elements
              }}
            >
              {/* Display filtered medicines */}
              {suggestApiCalled && (
                <div style={{ color: "red" }}>
                  No Exact Matches found ! You can search for the following
                  Suggestions.
                </div>
              )}

              <>
                {filteredOptions.map((op) => (
                  <div key={op}>
                    {
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {op.added ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <StyledButton
                              color="success"
                              sx={{
                                textAlign: "left",
                                justifyContent: "flex-start",
                                width: "100%",
                              }}
                            >
                              {op.term}
                            </StyledButton>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "row",
                                color: "green",
                                fontStyle: "bold",
                              }}
                            >
                              <span>&#10003;</span>
                              <span>(Added)</span>
                            </div>
                          </div>
                        ) : (
                          <StyledButton
                            color="grey"
                            sx={{
                              textAlign: "left",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                            onClick={() => {
                              skipEffect.current = true; // prevent debounce call
                              optionChosen.current = true;
                              setConditionName(op.term);
                              handleChangeMedicalHistory("condition", op);
                            }}
                            onMouseDown={() => setMouseDownOnOption(true)}
                          >
                            {op.term}
                          </StyledButton>
                        )}
                      </div>
                    }
                  </div>
                ))}
              </>
            </div>
          ) : filteredOptions.length == 0 &&
            debounceFunctionCalledCondition &&
            !termSelectedOrAdded ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "300px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              <div style={{ color: "red" }}>No Options Found!</div>
            </div>
          ) : null}
        </Grid>
        <Grid item xs={11} md={11} sm={11}>
          <StyledMultilineTextField
            id="outlined-multiline-static"
            label="Clinical Notes"
            multiline
            rows={2}
            value={medicalHistoryVars.clinical_note}
            onChange={(e) =>
              handleChangeMedicalHistory("clinical_note", e.target.value)
            }
            fullWidth
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearClinicalNotes}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>

                  <>
                    {/* {listeningOn === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="defaultColor"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : listeningOn === true &&
                      clinicalNotesListening === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="default"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Stop Listening">
                        <OutlinedIconFab
                          onClick={() => {
                            SpeechRecognition.stopListening();
                            setListeningOn(false);
                            setClinicalNotesListening(false);
                          }}
                          variant="outlined"
                          color="default"
                          size="small"
                        >
                          <KeyboardVoiceIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    )} */}
                  </>
                </div>
              ),
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={3} style={{ display: "flex" }}>
          <Tooltip title="How long ago the condition started">
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              Condition Onset:
            </span>
          </Tooltip>
          <StyledTextField
            type="number"
            label="Duration"
            variant="outlined"
            value={medicalHistoryVars.duration}
            onChange={(e) =>
              handleChangeMedicalHistory("duration", e.target.value)
            }
            fullWidth
          />
        </Grid>

        <Grid item xs={5} sm={5} md={3}>
          <StyledTextField
            select
            value={medicalHistoryVars.chiefComplaintDurationType} // Default to 'days'
            onChange={(e) =>
              handleChangeMedicalHistory(
                "chiefComplaintDurationType",
                e.target.value
              )
            }
            placeholder="Select Duration Type"
            fullWidth
            label="Duration Type"
          >
            {durationType.map((type) => (
              <MenuItem
                key={type.value}
                value={type.value}
                sx={{ fontSize: "12px" }}
              >
                {type.display}
              </MenuItem>
            ))}
          </StyledTextField>
        </Grid>
        <Grid item xs={11} sm={11} md={5}>
          <StyledTextField
            select
            value={medicalHistoryVars.clinical_status_description}
            onChange={(e) =>
              handleChangeMedicalHistory(
                "clinical_status_description",
                e.target.value
              )
            }
            placeholder="Select Clinical Status"
            fullWidth
            label="Clinical Status"
          >
            {chiefComplaintsStatus.map((status) => (
              <MenuItem key={status} value={status} sx={{ fontSize: "12px" }}>
                {status}
              </MenuItem>
            ))}
          </StyledTextField>
        </Grid>

        <Grid item xs={11} md={3} sx={{ display: "none" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <StyledDatePicker
                label="Start Date"
                onChange={(date) =>
                  handleChangeMedicalHistory("onset_datetime", date)
                }
                slotProps={{
                  field: { clearable: true },
                }}
                maxDate={today}
                value={
                  medicalHistoryVars?.onset_datetime
                    ? dayjs(medicalHistoryVars?.onset_datetime)
                    : null
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>

        {(medicalHistoryVars.clinical_status_description === "Resolved" ||
          medicalHistoryVars.clinical_status_description === "Remission") && (
          <>
            <Grid item xs={6} sm={2} md={2} style={{ display: "flex" }}>
              <Tooltip title="How long the patient had the condition">
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  Condition Duration:
                </span>
              </Tooltip>
              <StyledTextField
                label="Duration"
                fullWidth
                type="number"
                value={medicalHistoryVars.abatement_duration || ""}
                // error={!!validationErrors.duration}
                // helperText={validationErrors.duration}
                onChange={(e) =>
                  handleChangeMedicalHistory(
                    "abatement_duration",
                    e.target.value
                  )
                }
                onWheel={(e) => e.target.blur()} // Prevent scroll change
                InputProps={{
                  inputProps: {
                    style: {
                      // Hide arrows in Chrome, Safari, Edge
                      MozAppearance: "textfield",
                    },
                  },
                  sx: {
                    // Hide arrows in Firefox
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                    // Hide arrows in Chrome, Safari, Edge
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                  },
                }}
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <StyledTextField
                select
                fullWidth
                label="Duration Type"
                value={medicalHistoryVars.abatement_duration_type || "days"}
                onChange={(e) =>
                  handleChangeMedicalHistory(
                    "abatement_duration_type",
                    e.target.value
                  )
                }
              >
                {durationType.map((type) => (
                  <MenuItem
                    key={type.value}
                    value={type.value}
                    sx={{ fontSize: "12px" }}
                  >
                    {type.display}
                  </MenuItem>
                ))}
              </StyledTextField>
            </Grid>

            <Grid item xs={11} md={3} sx={{ display: "none" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <StyledDatePicker
                    label="End Date"
                    onChange={(date) =>
                      handleChangeMedicalHistory("abatement_datetime", date)
                    }
                    slotProps={{
                      field: { clearable: true },
                    }}
                    maxDate={today}
                    minDate={dayjs(medicalHistoryVars.onset_datetime)}
                    value={
                      medicalHistoryVars?.abatement_datetime
                        ? dayjs(medicalHistoryVars.abatement_datetime)
                        : null
                    }
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
          </>
        )}

        <Grid item xs={11} md={2}>
          <StyledButton
            bgColor="#0E3F66"
            onClick={
              medicalHistoryEditIndex !== null
                ? handleMedicalHistoryUpdate
                : handleAddRow
            }
            variant="contained"
            fullWidth
            color="defaultColor"
          >
            {medicalHistoryEditIndex !== null ? "Update" : "Add"}
          </StyledButton>
        </Grid>
        <Grid item xs={11} md={11} sm={11}>
          {error && <Typography style={{ color: "red" }}>{error}</Typography>}
        </Grid>
        <Grid item xs={11} sm={11}>
          {medicalHistoryData["prev"].length > 0 && (
            <StyledTableContainer
              component={Paper}
              // sx={{
              //   marginTop: "20px",
              //   border: "1px solid #21cdc0",
              // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Condition</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      Clinical Status
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Condition Onset
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Condition Duration
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {medicalHistoryData["prev"].map((row, rowIndex) => (
                    <StyledTableRowHistory key={rowIndex}>
                      <StyledTableCellHistory>
                        {row.condition}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory sx={{ width: "35%" }}>
                        {row.clinical_note.length > 0 ? row.clinical_note : "-"}
                      </StyledTableCellHistory>

                      <StyledTableCellHistory>
                        {row?.clinical_status_description ?? "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.onset_datetime
                          ? `${getHumanReadableDiffInPastDate(
                              row?.onset_datetime
                            )} ago`
                          : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.abatement_datetime
                          ? getHumanReadableDurationInDate(
                              row?.onset_datetime,
                              row?.abatement_datetime
                            )
                          : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>-</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
        <Grid item xs={11} sm={11}>
          {medicalHistoryData["new"].length > 0 && (
            <StyledTableContainer
              component={Paper}
              // sx={{
              //   margin: "5px 2px",
              //   border: "1px solid #21cdc0",
              // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Condition</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      Clinical Status
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Condition Onset
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Condition Duration
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {medicalHistoryData["new"].map((row, rowIndex) => (
                    <StyledTableRowHistory key={rowIndex}>
                      {/* {console.log("Medical History row", row)} */}

                      <StyledTableCellHistory>
                        {row?.condition}
                        {row?.source === "voice" && !row.id && (
                          <Tooltip title="Machine-interpreted text — please verify before confirming">
                            <span className="missing-id-warning">⚠️</span>
                          </Tooltip>
                        )}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory sx={{ width: "35%" }}>
                        {row?.clinical_note.length > 0
                          ? row.clinical_note
                          : "-"}
                      </StyledTableCellHistory>

                      <StyledTableCellHistory>
                        {row?.clinical_status_description ?? "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.duration
                          ? `${row?.duration} ${row?.chiefComplaintDurationType} ago`
                          : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.abatement_duration
                          ? `${row?.abatement_duration} ${row?.abatement_duration_type}`
                          : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {medicalHistoryData["prev"].includes(row) ? (
                          "-"
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Tooltip title="Edit">
                              <OutlinedIconFab
                                onClick={() =>
                                  handleMedicalHistoryEditClick(row, rowIndex)
                                }
                                sx={{ marginRight: 1 }}
                              >
                                <Icon name="editInTable" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <OutlinedIconFab
                                onClick={() =>
                                  handleMedicalHistoryDelete(rowIndex)
                                }
                              >
                                <Icon name="deleteInTable" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>
                        )}
                      </StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default React.memo(MedicalHistory);
